import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/staffs/Page';
import { NskHead } from '~/components/common/head/NskHead';
import { useStaffs } from '~/hooks/useStaffs';
import useItandiAccount from '~/hooks/useItandiAccount';
import Loading from '~/components/common/parts/loading/Loading';

export const PATH = '/settings/staffs';

const Home: NextPage = () => {
  const staffs = useStaffs().data;
  const currentAccount = useItandiAccount().currentAccount().data;
  if (
    staffs === null ||
    currentAccount === null ||
    currentAccount.company === null
  ) {
    return <Loading isLoading />;
  }

  return (
    <>
      <NskHead title="担当者一覧" />
      <Component currentCompany={currentAccount.company} staffs={staffs} />
    </>
  );
};
export default Home;
